module.exports = __webpack_public_path__ + "images/tg11x5ff.2046.png";